// extracted by mini-css-extract-plugin
module.exports = {"wrapperContent":"PopoverElement_wrapperContent__JDQEE","wrapperBody":"PopoverElement_wrapperBody__2KBgT","wrapperFooter":"PopoverElement_wrapperFooter__gp32-"};